import { Grid, makeStyles } from '@material-ui/core';
import React from 'react';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';

const useStyles = makeStyles(_ => ({
    root: {
        maxWidth: '80%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: 20
    },
}));

const ProfilePage : React.FC = () => {
    const classes = useStyles();

    useDocumentTitle("Profile");
    
    return (
        <Grid container direction='column' className={`${classes.root} flex-gap-4`} alignItems="center">
            {/* <Grid item>
                <Typography variant='h1'>My Profile</Typography>
            </Grid> */}
            <Grid item>

            </Grid>
        </Grid>
    )
}

export default ProfilePage;